import { ArrowDownRight, MapPin } from "lucide-react";
import { profile } from "../../data/resume";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden"
    >
      {/* Background image + overlays */}
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.pexels.com/photos/11991914/pexels-photo-11991914.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400"
          alt="Minimalist architecture against a clear sky"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-paper via-paper/95 to-paper/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-paper via-transparent to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-[0.24em] font-semibold text-brass mb-6 animate-fade-up" style={{ animationDelay: "0.05s", opacity: 0 }}>
            {profile.title}
          </p>

          <h1
            data-testid="hero-headline"
            className="font-serif font-bold text-ink text-[2.6rem] sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight animate-fade-up"
            style={{ animationDelay: "0.15s", opacity: 0 }}
          >
            {profile.heroHeadline}
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-7 text-lg sm:text-xl text-slatey leading-relaxed max-w-2xl animate-fade-up"
            style={{ animationDelay: "0.3s", opacity: 0 }}
          >
            {profile.heroSub}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4 animate-fade-up" style={{ animationDelay: "0.45s", opacity: 0 }}>
            <a
              href="#experience"
              data-testid="hero-primary-cta"
              className="group inline-flex items-center justify-center gap-2 bg-ink text-white px-8 py-4 text-sm font-medium hover:bg-slate-800 transition-colors"
            >
              View experience
              <ArrowDownRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5" strokeWidth={1.5} />
            </a>
            <a
              href="#contact"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-2 border border-ink/30 text-ink px-8 py-4 text-sm font-medium hover:border-ink hover:bg-ink/[0.03] transition-colors"
            >
              Get in touch
            </a>
          </div>

          <div className="mt-12 flex items-center gap-2 text-sm text-slate-500 animate-fade-up" style={{ animationDelay: "0.6s", opacity: 0 }}>
            <MapPin className="h-4 w-4 text-brass" strokeWidth={1.5} />
            <span>{profile.location}</span>
            <span className="mx-2 text-slate-300">/</span>
            <span>{profile.credentials}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
